export default {
  accepted: 'Accepté',
  accessRequestDate: "Date de la demande d'accès",
  confirmUserWillBeSystemAdmin: "L'utilisateur sera administrateur système. Continuer ?",
  copyInvitationLink: "Copier le lien d'invitation dans le presse-papiers",
  copyInvitationLinkConfirmMessage: `Si l'utilisateur invité n'a reçu aucun e-mail à l'adresse {{email}},
vous pouvez copier le lien d'invitation dans le presse-papiers et le partager avec lui d'autres façons.

Copier le lien d'invitation dans le presse-papiers ?`,
  copyPasswordResetLink: 'Copier le lien de réinitialisation du mot de passe dans le presse-papiers ?',
  copyPasswordResetLinkConfirmMessage: `Si l'utilisateur a réinitialisé son mot de passe mais n'a reçu aucun e-mail à l'adresse {{email}},
vous pouvez copier le lien de réinitialisation du mot de passe dans le presse-papiers et le partager avec lui d'autres façons.

Copier le lien de réinitialisation du mot de passe dans le presse-papiers ?`,
  editSurveyUserExtraPropsForUser:
    'Modifier les propriétés supplémentaires de l\'utilisateur du formulaire pour l\'utilisateur "{{userName}}"',
  inviteUser: 'Inviter',
  invitationExpiredClickToSendAgainTheInvitation: "Invitation expirée : cliquez pour envoyer à nouveau l'invitation",
  invitationLinkCopiedToClipboard: "Lien d'invitation copié dans votre presse-papiers",
  invitedBy: 'Invité(e) par',
  invitedDate: "Date d'invitation",
  lastLogin: 'Dernière connexion',
  moreThan30DaysAgo: 'Il y a plus de 30 jours',
  notAcceptedYet: 'Invitation non encore acceptée',
  passwordResetLinkCopiedToClipboard: 'Lien de réinitialisation du mot de passe copié dans votre presse-papiers',
  passwordResetLink: 'Lien de réinitialisation du mot de passe',
  prefs: {
    title: 'Préférences de notification',
    notifyOnUserAccessRequest: "Nouvelles demandes d'accès des utilisateurs",
  },
  roleInCurrentSurvey: 'Rôle dans le formulaire actuel',
  roleInSurvey: 'Rôle dans le formulaire',
  filterPlaceholder: 'Filtrer par nom ou e-mail',
  surveyName: 'Nom du formulaire',
  surveyExtraProp: {
    label: 'Propriété supplémentaire du formulaire',
    label_other: 'Propriétés supplémentaires du formulaire',
  },
  surveysDraft: 'Formulaires (brouillon)',
  surveysPublished: 'Formulaires (publiés)',
  userRemovedFromSurveyGoToSurveysRequired: `Vous avez été retiré de ce formulaire.  
Appuyez sur Aller aux formulaires pour ouvrir la liste des formulaires.`,
  userRoleUpdatedRefreshRequired: `Votre rôle dans ce formulaire a été mis à jour.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Nouveau groupe',
    edit: 'Modifier le groupe',
    name: 'Nom',
    label: 'Libellé',
    qualifier: 'Qualificatif {{index}}',
    qualifier_plural: 'Qualificatifs',
    qualifierKey: 'Clé',
    qualifierValue: 'Valeur',
    addQualifier: 'Ajouter un qualificatif',
    members: 'Membres',
    addMember: 'Ajouter un membre',
    noMembers: "Aucun membre pour l'instant",
    memberAlreadyInGroup: 'Actuellement dans "{{groupName}}"',
    tabs: {
      groups: "Groupes d'utilisateurs",
      assignments: 'Attribution des groupes',
      report: 'Rapport des membres',
    },
    memberName: 'Nom du membre',
    memberEmail: 'E-mail du membre',
    memberRole: 'Rôle dans le formulaire',
    memberStatus: 'Statut',
    status: {
      INVITED: 'Invité',
      ACCEPTED: 'Accepté',
      FORCE_CHANGE_PASSWORD: 'Changement de mot de passe requis',
    },
    unassigned: 'Non assigné',
    confirmDelete: 'Supprimer le groupe "{{name}}" ? Ses membres deviendront non assignés. Continuer ?',
    deleteConfirmed: 'Le groupe "{{name}}" a été supprimé',
    saveConfirmed: 'Le groupe "{{name}}" a été enregistré',
    confirmReassign:
      '{{userName}} est actuellement dans le groupe "{{groupName}}". Le déplacer vers ce groupe à la place ?',
    notFound: 'Groupe introuvable',
  },
  updateUserConfirmation: "L'utilisateur {{name}} a été mis à jour",
  userNotInvitedToAnySurvey: `Utilisateur non invité à aucun formulaire`,
  userSurveys: "Formulaires de l'utilisateur",
}
